import { apiClient } from "../lib/api";

export const contractApi = {
  listTemplates: () => apiClient.get("/contracts/templates"),
  createTemplate: (payload) => apiClient.post("/contracts/templates", payload),
  generate: (employee_id, template_id) => apiClient.post("/contracts/generate", { employee_id, template_id }),
  getByEmployee: (employeeId) => apiClient.get(`/contracts/by-employee/${employeeId}`),
  updateDraft: (contractId, payload) => apiClient.patch(`/contracts/${contractId}`, payload),
  sendForSignature: (contractId) => apiClient.post(`/contracts/${contractId}/send-for-signature`),
  signEmployee: (contractId, typed_name) => apiClient.post(`/contracts/${contractId}/sign-employee`, { typed_name }),
  signCompany: (contractId, typed_name) => apiClient.post(`/contracts/${contractId}/sign-company`, { typed_name }),
};
